import { useForm, yupResolver } from '@mantine/form';
import * as yup from 'yup';

import { useAccount } from '../../store/account/hooks';
import { useDomains } from '../../store/domains/hooks';
import { Button, EmailWithDomainInput, Input } from 'ui';

const formValidation = yup.object({
  senderName: yup.string().required('Sender name is required.').min(2, 'Sender name is invalid.'),
  senderEmail: yup.string().test('email-prefix', 'Invalid value.', (val) => {
    if (!val || val?.length < 2) return false;
    return !val.includes('@');
  }),
});

const FromSettings = () => {
  const { account, updateEmailPreferences, saveEmailPreferences } = useAccount();
  const { domain } = useDomains();
  const form = useForm({
    initialValues: {
      senderName: account?.emailPreferences?.senderName || '',
      senderEmail: account?.emailPreferences?.senderEmail?.split('@')[0] || '',
    },
    validate: yupResolver(formValidation),
    validateInputOnBlur: true,
  });

  const hasPendingChanges = form.isDirty() && form.isValid();

  return (
    <div>
      <div className="pt-6">
        <form className="grid grid-cols-2 gap-4 px-4" noValidate>
          <Input
            id="name"
            label="From Name"
            {...form.getInputProps('senderName')}
            placeholder="Insert Name"
            required
            helperText={form.errors.senderName || 'The name subscribers will see as the sender'}
            labelClassName="w-[125px] mr-[5%]"
          />

          <EmailWithDomainInput
            id="email"
            label="From Address"
            {...form.getInputProps('senderEmail')}
            authenticatedDomain={domain?.domain}
            placeholder="Insert Email"
            required
            helperText={form.errors.senderEmail || 'The address subscribers will see as the sender'}
          />
        </form>
      </div>
      <div className="px-4 py-6">
        <Button
          title="Save Changes"
          color="primary"
          onClick={form.onSubmit((values) => {
            updateEmailPreferences({
              ...values,
              senderEmail: values.senderEmail ? `${values.senderEmail}@${domain?.domain}` : '',
            });
            saveEmailPreferences();
          })}
          disabled={!hasPendingChanges}
        />
      </div>
    </div>
  );
};

export default FromSettings;
